import React from 'react';

interface Props {
  width?: number;
  height?: number;
  fill?: string | number;
}

function YfiIcon({
  width = 50,
  height = 50,
  ...props
}: Props & React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 30 30" width={width} height={height} {...props}>
      <path
        opacity={0.2}
        d="M29.92 15c0 8.24-6.68 14.921-14.92 14.921-8.242 0-14.922-6.68-14.922-14.92C.078 6.76 6.758.078 15 .078 23.24.08 29.92 6.76 29.92 15z"
        fill="#B8C5D3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 3c6.626 0 12 5.374 12 12s-5.374 12-12 12S3 21.626 3 15 8.374 3 15 3z"
        fill="#006AE3"
      />
      <path d="M14.504 20.06v-9.985h1.087v9.984h-1.087z" fill="#fff" />
      <path
        d="M20.04 13.402l-3.358.89-.749-3.485.998-.225.394 1.65s.907-1.487-.302-3.028c-.713-.792-1.051-.826-1.85-.95-.704-.101-2.338.136-2.825 2.044-.207 1.23.026 2.139 1.61 3.33l-.089 1.324s-1.769-1.246-2.225-2.12c-.353-.69-.957-2.056.135-3.957.588-.95 1.747-1.862 3.79-1.766 1.027.043 3.534 1.298 3.146 4.231-.067.55-.353 1.282-.353 1.282l1.378-.308.3 1.088zM18.123 21.214c-.615.933-1.798 1.814-3.835 1.665-1.028-.07-3.5-1.392-3.034-4.313.082-.547.386-1.27.386-1.27l-1.384.27-.272-1.092 3.382-.802.658 3.504-1.006.2-.35-1.664s-.946 1.462.22 3.036c.692.811 1.028.852 1.827.998.698.12 2.34-.076 2.877-1.97.238-1.222.03-2.138-1.521-3.372l.125-1.322s1.735 1.29 2.167 2.176c.331.704.9 2.086-.24 3.956z"
        fill="#fff"
      />
    </svg>
  );
}

const MemoYfiIcon = React.memo(YfiIcon);
export default MemoYfiIcon;
